import { Injectable, EventEmitter } from '@angular/core';
/**
 * @hidden
 */
var DomEventsService = /** @class */ (function () {
    function DomEventsService() {
        this.cellClick = new EventEmitter();
        this.cellMousedown = new EventEmitter();
        this.click = new EventEmitter();
        this.keydown = new EventEmitter();
        this.focus = new EventEmitter();
        this.focusIn = new EventEmitter();
        this.focusOut = new EventEmitter();
        this.windowBlur = new EventEmitter();
    }
    DomEventsService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    DomEventsService.ctorParameters = function () { return []; };
    return DomEventsService;
}());
export { DomEventsService };



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/common/dom-events.service.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/common/dom-events.service.js
// module chunks = vendor